<template>
  <small>
    {{ $t('pagination.showing') }}
    {{ from }}
    {{ $t('pagination.to') }}
    {{ to }}
    {{ $t('pagination.of') }}
    {{ total }}
    {{ $t('pagination.entries') }}
  </small>
</template>

<script>
export default {
  props: {
    page: {
      type: Number,
      default: 1
    },
    pageSize: {
      type: Number,
      default: 10
    },
    shown: {
      type: Number,
      default: 0
    },
    total: {
      type: Number,
      default: 0
    }
  },

  computed: {
    from () {
      return this.total
        ? 1 + (this.page - 1) * this.pageSize
        : this.total
    },
    to () {
      return this.total
        ? this.from - 1 + this.shown
        : this.total
    }
  }
}
</script>
